export default "__VITE_ASSET__CQA2Dy5f__"